import { useCallback } from "react";
import { useVersionWatcher } from "./useVersionWatcher";

/**
 * Detecta cuando el propio POS se redeployó (version.json cambia, generado
 * por pos/.github/workflows/main.yml en cada build) y fuerza un refresh —
 * análogo a useBackendVersionWatcher pero para el frontend del POS mismo,
 * no el backend. Se lee como archivo estático del propio origen, no vía la
 * API del backend, y con cache-busting explícito para no leer un
 * version.json cacheado por el navegador.
 */
export const usePosVersionWatcher = () => {
  const getVersion = useCallback(async () => {
    const res = await fetch(`/version.json?_t=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    return data?.version ?? null;
  }, []);

  useVersionWatcher(getVersion, "POS");
};
